export enum InvoiceDiscountType {
  Amount = 'amount',
  Percentage = 'percentage',
}
